import { render, staticRenderFns } from "./EventDetailsTabStaffing.vue?vue&type=template&id=8b2e7054"
import script from "./EventDetailsTabStaffing.vue?vue&type=script&lang=js"
export * from "./EventDetailsTabStaffing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports